export const WEB_SERVICE = "https://rgsweb.eodyne.com/rgsmims/backend/dashboard/src";
export const primaryColor = "#26A9B6";
